import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../App';
import dao from '../../assets/img/dao.png'
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { LoadingFull, LoadingOverlay } from '../../components/loading';
import { IoIosArrowBack } from "react-icons/io";
import { MdArrowForwardIos } from "react-icons/md";
import Modal from './modal';

const BookDetail = () => {

  const { dbId } = useParams();
  const [data, setData] = useState();
  const [selectedImage, setSelectedImage] = useState(0)
  const [load, setLoad] = useState(false)
  const [thumbLoaded, setThumbLoaded] = useState(false)
  const navigate = useNavigate()
  const { user, auth, setContentLoaded } = useContext(UserContext)
  const smallImages = []
  const [otherBooks, setOtherBooks] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [showInfo, setShowInfo] = useState()
  const infoRef = useRef(null)
  const token = localStorage.getItem('token')

  if (typeof data !== 'undefined') {
    for (let i = 0; i < data.dbBook['images']; i++) {
      smallImages.push(
        <div className={"cursor-pointer content-center p-2 xl:h-fit " + (selectedImage === i ? " ring-2 ring-emerald-500" : "")} onClick={() => setSelectedImage(i)}>
          <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${i}?alt=media`} alt="BOOK" className={"w-full h-auto"} loading="eager" />
        </div>
      )
    }
  }

  useEffect(() => {
    setLoad(true)
    setOtherBooks([])
    axios({
      method: 'post',
      url: '/api/findBook',
      data: {
        'dbId': dbId
      },
    })
    .then(response => {
      setData(response.data);
      setContentLoaded(true)
      setLoad(false)
      if (response.data.buyBook.ownerHasOthers) {
        axios({
          method: 'post',
          url: '/api/booksFromSS',
          data: {
            'dbId': response.data.dbBook._id,
            'sellerId': response.data.dbBook.ejer
          },
        })
        .then(response => {
          setOtherBooks(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      }
    })
    .catch(error => {
      console.log(error);
    });
  }, [dbId]);

  const handleBuy = () => {
    if (localStorage.getItem('basket') !== null) {
      if (!localStorage.getItem('basket').includes(data.dbBook._id)) {
        localStorage.setItem('basket', (localStorage.getItem('basket') ? localStorage.getItem('basket').split(',') : []).concat(data.dbBook._id).join(','))
      }
    } else {
      localStorage.setItem('basket', data.dbBook._id)
    }
    setOpenModal(true)
  }

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollAmount = 300; // juster som ønsket
    container.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
  };

  function CustomArrow({ direction }) {
    return (
      <div
        className={`absolute top-1/2 -translate-y-1/2 z-10 cursor-pointer 
          w-10 md:w-12 h-10 md:h-12 flex items-center justify-center rounded-full
          bg-white shadow-lg transition text-lg md:text-xl
          ${direction === 'left' ? '-left-2 sm:-left-5 md:-left-10 lg:-left-16' : '-right-2 sm:-right-5 md:-right-10 lg:-right-16'}
        `}
        onClick={() => scroll(direction)}
      >
        <IoIosArrowBack className={direction === 'left' ? "" : "rotate-180"} />
      </div>
    );
  }

  return (
    <>
      {typeof data !== 'undefined' && !load ?
        <div className="py-[100px] min-h-lvh">
          <div className="innerContainer mx-auto h-full">
            <div className="box h-full space-y-10">
              <div className="block md:flex sm:gap-10 h-full">
                <div className="bookImage flex-[1] flex flex-col xl:flex-row-reverse gap-5">
                  <div className="w-full relative">
                    {(!thumbLoaded) ?
                      <div className="absolute w-full h-full">
                        <LoadingFull />
                      </div>
                    :
                      ""}
                    <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${selectedImage}?alt=media&t=${new Date().getTime()}`} alt="BOOK" className="object-contain w-full max-h-lvh h-72 sm:h-96 md:h-auto" style={{"max-height": "-webkit-fill-available"}} onLoad={() => setThumbLoaded(true)} loading="eager" />
                  </div>
                  <div className={`gallery grid grid-cols-5 xl:grid-cols-1 flex-row xl:w-20 w-full gap-2 h-fit`}>
                    {Array.from({ length: data.dbBook['images'] }).map((_, index) => {
                      return (
                        <div className={"cursor-pointer content-center p-2 xl:h-fit " + (selectedImage === index ? " ring-2 ring-emerald-500" : "")} onClick={() => setSelectedImage(index)}>
                          <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${index}?alt=media&t=${new Date().getTime()}`} alt="BOOK" className={"w-full h-auto"} loading="eager" />
                        </div>
                      )
                    })}
                  </div>
                </div>
                <div className="bookInfo justify-between flex flex-col flex-[1.5] h-auto">
                  <div className="flex flex-col gap-5 md:gap-10 h-full py-10">
                    <div className="praktisk flex flex-col gap-5">
                      <div className="title space-y-2">
                        <h1 className="text-2xl lg:text-3xl font-semibold">{data.apiBook.title}</h1>
                        <p className="text-base lg:text-lg text-gray-700">
                          {data.apiBook.director.length > 0 ?
                            <span className="">
                                {data.apiBook.director.map((dir, index) => {
                                  if (index !== 0) {
                                      return `, ${dir['$']}`
                                  } else {
                                      return ` ${dir['$']}`
                                  }
                                })}
                            </span>
                          :
                            "Ukendt forfatter"}
                        </p>
                      </div>
                      <div className="description flex flex-col gap-2">
                        <p className="text-sm lg:text-base text-gray-700 font-medium">ISBN:
                          <span className="font-normal"> {data.apiBook.isbn}</span>
                        </p>
                        <p className="text-sm lg:text-base text-gray-700 font-medium">Udgave:
                          <span className="font-normal">
                            {data.apiBook.version !== '' ?
                                " " + data.apiBook.version
                              :
                                " 1. udgave"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="flex-wrap gap-y-5 flex gap-x-10 items-start">
                      <div className="flex gap-x-10">
                        <div className="flex flex-col justify-between gap-1">
                          <h1 className="text-sm sm:text-base">Pris</h1>
                          <div className="h-full content-center">
                            <p className="text-2xl lg:text-2xl font-bold select-none leading-none">{Number(data.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                          </div>
                        </div>
                        <div className="flex flex-col justify-between gap-1">
                          <h1 className="text-sm sm:text-base">Stand</h1>
                          <div className="h-full leading-none content-center">
                            <h2 className={"text-sm font-semibold uppercase hover:bg-pos-100 cursor-pointer bg-gradient-to-r bg-pos-0 bg-size-200 text-white w-fit px-4 py-1 " + (data?.dbBook.stand === 1 ? "from-emerald-600 to-emerald-700" : data?.dbBook.stand === 2 ? "from-emerald-600 to-emerald-700" : "from-emerald-600 to-emerald-700")}>{(typeof data !== 'undefined') ? (data.dbBook.stand === 1) ? "Meget brugt" : (data.dbBook.stand === 2) ? "Lettere brugt" : "Som ny" : "Loading..."}</h2>
                          </div>
                        </div>
                      </div>
                      {(data.dbBook.desc !== '') ?
                        <div className="flex flex-col justify-between gap-1">
                          <h1 className="text-sm sm:text-base">Beskrivelse</h1>
                          <div className="h-full leading-none text-neutral-600 content-center">
                            <p dangerouslySetInnerHTML={{
                              __html: data.dbBook.desc.replace(/\r\n/g, "<br />"),
                            }} />
                          </div>
                        </div>
                      :
                        ""
                      }
                    </div>
                    <hr></hr>
                    <div className="h-full flex gap-2 select-none flex-col">
                      <div className="options border border-neutral-200 p-5 w-full">
                        <div className="flex gap-4 flex-col lg:flex-row lg:justify-between lg:items-center">
                          <h2 className="text-sm lg:text-base font-medium">
                            Har du spørgsmål om denne bog?
                          </h2>
                          <div className="text-sm lg:text-base font-medium cursor-pointer text-center text-nowrap text-white px-5 py-2 bg-gradient-to-r from-emerald-500 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-[]" onClick={() => navigate(`/indbakke?book=${data.dbBook._id}`)}>Spørg sælgeren</div>
                        </div>
                      </div>
                      <div className="flex gap-2 flex-col 2xl:flex-row w-full">
                        <div className="options border border-neutral-200 p-5 w-full flex justify-between items-center">
                          <h2 className="text-sm lg:text-base font-semibold">
                            Forsendelse med DAO
                          </h2>
                          <div className="img w-10 h-auto">
                            <img src={dao} alt="" className="h-full w-full object-contain" />
                          </div>
                        </div>
                        {(data.buyBook.pickup) ?
                          <>
                            <div class="flex items-center text-xs text-neutral-400 uppercase before:flex-1 before:border-t before:border-neutral-200 before:me-6 after:flex-1 after:border-t after:border-neutral-200 after:ms-6">eller</div>
                            <div className="options border border-neutral-200 p-5 w-full flex items-center justify-between gap-5">
                              <div className="flex flex-col gap-2">
                                <h2 className="text-sm lg:text-base font-semibold">
                                  Du kan afhente hos sælgeren
                                </h2>
                                <div className="address text-sm lg:text-base">
                                  {(typeof data !== 'undefined') ?
                                    <>
                                      <p>{data.soldBook.pickup_address.postal_code} {data.soldBook.pickup_address.city}</p>
                                      <p className="text-sm">Addressen oplyses ved køb</p>
                                    </>
                                  :
                                    ""
                                  }
                                </div>
                              </div>
                              <IoMdCheckmarkCircleOutline size="40px" className="text-emerald-600" />
                            </div>
                          </>
                        :
                          ""
                        }
                      </div>
                    </div>
                  </div>
                  <div className="buySection sticky bottom-10">
                    {data.dbBook.sold ?
                      ""
                    : auth && data.dbBook.ejer === user._id ?
                      <>
                        <div className="shadow-lg cursor-pointer text-white bg-gradient-to-r from-emerald-500 to-emerald-800 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-[] py-2 px-8 text-md font-medium text-center bottom-0" onClick={() => navigate(`/dashboard/editBook?book=${data.dbBook._id}`)}>Rediger</div>
                      </>
                    :
                      <>
                        <div className="shadow-lg cursor-pointer text-white bg-gradient-to-r from-emerald-500 to-emerald-800 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-[] py-2 px-8 text-md font-medium text-center bottom-0" onClick={() => handleBuy()}>Læg i kurv</div>
                      </>
                    }
                  </div>
                </div>
              </div>
              {data.buyBook.ownerHasOthers &&
              <>
                <hr></hr>
                <div className="otherBooks space-y-4">
                  <div className="">
                    <h2 className="text-lg lg:text-xl font-semibold">Flere bøger fra samme sælger</h2>
                    <p className="text-sm sm:text-base">Du sparer penge på forsendelse, når du køber fra den samme sælger.</p>
                  </div>
                  <div className="books relative">
                    {otherBooks.length === 0 ?
                      <div className="h-28">
                        <LoadingFull />
                      </div>
                    :
                      <>
                        <div className="overflow-x-auto scroll-smooth no-scrollbar" ref={scrollRef}>
                          <div className="flex gap-5">
                            {otherBooks.map((book, index) => {
                              return (
                                <div className="book cursor-pointer h-full flex flex-col gap-x-6 justify-between w-28 sm:w-40" onClick={() => navigate(`/bøger/${book.dbBook._id}`)}>
                                  <div className="flex flex-col gap-2 w-28 sm:w-40">
                                    <div className="aspect-h-1 aspect-w-1 w-full h-40 sm:h-56 bg-neutral-100 xl:aspect-h-8 xl:aspect-w-7 p-2">
                                      <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} className="h-full w-auto object-contain m-auto" alt="Slide 1" />
                                    </div>
                                    <div className="flex flex-col">
                                      <h5 className="text-sm md:text-sm xl:text-base text-gray-700 font-medium">{book.apiBook.title}</h5>
                                      <p className="text-sm text-gray-700 font-normal">{book.apiBook.director.map((dir, index) => {
                                        if (index !== 0) {
                                            return `, ${dir['$']}`
                                        } else {
                                            return ` ${dir['$']}`
                                        }
                                      })}</p>
                                    </div>
                                  </div>
                                  <p className="text-base font-medium select-none">{Number(book.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                        <CustomArrow direction="left" />
                        <CustomArrow direction="right" />
                      </>}
                  </div>
                </div>
              </>}
            </div>
            <Modal width={"w-[90%] md:w-[85%] lg:w-[80%] xl:w-[1000px]"} height={"fit max-h-[90%] overflow-y-auto"} open={openModal} onClose={() => setOpenModal(false)}>
              <div className="space-y-8">
                <div className="text-center space-y-2">
                  <IoMdCheckmarkCircleOutline className="mx-auto text-emerald-600 text-4xl sm:text-5xl" />
                  <h2 className="font-medium sm:text-lg md:text-xl">Bogen er tilføjet til din kurv</h2>
                </div>
                <div className="space-y-4">
                  <div className="relative flex h-full gap-x-2 sm:gap-x-5 font-medium cursor-pointer md:pointer-events-none bg-neutral-100 ring-1 ring-neutral-200 p-4" onClick={() => setShowInfo(!showInfo)}>
                    <div className="shrink-0 bookImage aspect-square w-16 sm:w-20 md:w-32 h-full bg-neutral-100">
                      <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F0?alt=media`} alt='BOOK' className="m-auto w-full h-full object-contain bg-neutral-100" />
                    </div>
                    <div className="bookInfo overflow-x-hidden">
                      <div className="praktisk flex flex-col gap-2 text-sm xl:text-base">
                        <div className="">
                          <h1 className="font-semibold md:text-lg truncate">{data.apiBook.title}</h1>
                          <div className="hidden md:block space-y-1">
                            <p className="text-sm lg:text-base text-gray-700 font-normal">
                              {(typeof data.apiBook.director !== 'undefined') ? 
                                data.apiBook.director.length > 0 ?
                                  data.apiBook.director.map((dir, index) => {
                                    if (index !== 0) {
                                        return `, ${dir['$']}`
                                    } else {
                                        return ` ${dir['$']}`
                                    }
                                  })
                                :
                                  "Ukendt forfatter"
                              :
                                " Loading..."}
                            </p>
                            <div className="">
                              <p className="text-gray-700 font-medium">Udgave: <span className="font-normal">{data.apiBook.version}</span></p>
                              <p className="text-sm lg:text-base text-gray-700 font-medium">ISBN:
                                <span className="font-normal">
                                  {(typeof data.apiBook.isbn !== 'undefined') ? 
                                    " " + data.apiBook.isbn
                                  : "Loading..."}
                                </span>
                              </p>
                            </div>
                          </div>
                          <p className="font-medium md:mt-1">{Number(data.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                        </div>
                        <div className="md:hidden">
                          <div className="text-sm flex gap-1 items-center">
                            Se info
                            <MdArrowForwardIos className={`transition-[] ${showInfo ? "rotate-90" : ""}`} />
                          </div>
                          <div ref={infoRef}
                            className="overflow-hidden transition-max-height duration-300 ease-in-out"
                            style={{ maxHeight: showInfo ? `${infoRef.current?.scrollHeight}px` : "0" }}>
                            <p className="text-sm lg:text-base text-gray-700 font-medium">Forfatter:
                              {(typeof data.apiBook.director !== 'undefined') ? 
                                data.apiBook.director.length > 0 ?
                                  <span className="italic font-normal">
                                      {data.apiBook.director.map((dir, index) => {
                                        if (index !== 0) {
                                            return `, ${dir['$']}`
                                        } else {
                                            return ` ${dir['$']}`
                                        }
                                      })}
                                  </span>
                                :
                                  <span className="font-normal"> Ukendt forfatter</span>
                              :
                                " Loading..."}
                            </p>
                            <p className="text-gray-700 font-medium">Udgave: <span className="font-normal">{data.apiBook.version}</span></p>
                            <p className="text-sm lg:text-base text-gray-700 font-medium">ISBN:
                              <span className="font-normal">
                                {(typeof data.apiBook.isbn !== 'undefined') ? 
                                  " " + data.apiBook.isbn
                                : "Loading..."}
                              </span>
                            </p>
                            <div className="flex gap-2 items-center relative">
                              <p className="text-xs lg:text-sm font-semibold uppercase">{data.dbBook.stand === 1 ? "Meget brugt" : data.dbBook.stand === 2 ? "Lettere brugt" : "Som ny"}</p>
                              <div className="flex group md:relative flex-wrap-reverse" tabindex="0">
                                <div className="q-mark cursor-pointer group-focus:text-gray-500">
                                  <svg class="w-4 h-4 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
                                </div>
                                <div className="">
                                  <div class="q-text left-0 invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 absolute bottom-[25px] z-10 w-64 text-sm transition-opacity duration-100 bg-white border border-gray-200 shadow-sm">
                                    <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                                        <h3 class="font-semibold text-gray-900 dark:text-white">Stand</h3>
                                    </div>
                                    <div class="px-3 py-2 flex flex-col gap-2">
                                      <p>Denne bog er vurderet som <span className="uppercase font-medium">{(data.dbBook.stand === 1) ? "Meget brugt" : (data.dbBook.stand === 2) ? "Lettere brugt" : "Som ny"}</span>, hvilket betyder:</p>
                                      <p>{(data.dbBook.stand === 1) ? "Tydelige slidtegn, krøllet omslag, muligvis noter og pletter. Alle sider intakte." : (data.dbBook.stand === 2) ? "Mindre tegn på brug, bøjede hjørner, muligvis enkelte noter. God stand." : "Næsten ubrugt, ingen synlige slidtegn eller markeringer. Perfekt stand."}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ml-auto w-full flex flex-col sm:flex-row gap-2">
                    <div className="w-full cursor-pointer text-white bg-gradient-to-r from-emerald-500 to-emerald-700 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-[] py-2 px-8 text-md font-medium text-center bottom-0" onClick={() => navigate('/checkout')}>Gå til kurven</div>
                    <div className="w-full cursor-pointer text-emerald-700 ring-inset ring-1 ring-emerald-600 bg-size-200 bg-pos-0 hover:bg-neutral-100 transition-[] py-2 px-8 text-md font-medium text-center bottom-0" onClick={() => setOpenModal(false)}>Fortsæt shopping</div>
                  </div>
                </div>
                {data.buyBook.ownerHasOthers &&
                <>
                  <hr></hr>
                  <div className="otherBooks space-y-4">
                    <div className="">
                      <h2 className="text-lg lg:text-xl font-medium">Flere bøger fra samme sælger</h2>
                      <p className="text-sm sm:text-base">Du sparer penge på forsendelse, når du køber fra den samme sælger.</p>
                    </div>
                    <div className="books relative">
                      {otherBooks.length === 0 ?
                        <div className="h-28">
                          <LoadingFull />
                        </div>
                      :
                        <div className="overflow-x-auto scroll-smooth">
                          <div className="flex gap-5">
                            {otherBooks.map((book, index) => {
                              return (
                                <div className="book cursor-pointer h-auto flex flex-col gap-x-6 justify-between w-28 sm:w-40" onClick={() => navigate(`/bøger/${book.dbBook._id}`) & setOpenModal(false)}>
                                  <div className="flex flex-col gap-2 w-28 sm:w-40">
                                    <div className="aspect-h-1 aspect-w-1 w-full h-40 sm:h-56 bg-neutral-100 xl:aspect-h-8 xl:aspect-w-7 p-2">
                                      <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} className="h-full w-auto object-contain m-auto" alt="Slide 1" />
                                    </div>
                                    <div className="flex flex-col">
                                      <h5 className="text-sm md:text-sm xl:text-base text-gray-700 font-medium truncate sm:whitespace-normal sm:overflow-visible sm:text-clip">{book.apiBook.title}</h5>
                                      <p className="text-sm text-gray-700 font-normal truncate">{book.apiBook.director.map((dir, index) => {
                                        if (index !== 0) {
                                            return `, ${dir['$']}`
                                        } else {
                                            return ` ${dir['$']}`
                                        }
                                      })}</p>
                                    </div>
                                  </div>
                                  <p className="text-base font-medium select-none">{Number(book.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                                </div>
                              )
                            })}
                          </div>
                        </div>}
                    </div>
                  </div>
                </>}
              </div>
            </Modal>
          </div>
        </div>
      :
        <div className="h-lvh">
          <LoadingFull />
        </div>}
    </>
  )
}


export default BookDetail;